
import { defineComponent } from "vue";
import CobraBenefits from "@/components/benefits/CobraBenefits.vue";
import GroupInsuranceBenefits from "@/components/benefits/GroupInsuranceBenefits.vue";
import { mapGetters, mapMutations } from "vuex";
import helper from "@/utils/helper";

export default defineComponent({
  components: { CobraBenefits, GroupInsuranceBenefits },
  data() {
    return {
      enrollmentType: 0,
    };
  },
  async created() {
    this.enrollmentType = this.getEnrollment.serviceType;
  },
  beforeRouteLeave(to, from, next) {
    helper.beforeRouterLeave(next);
  },
  computed: {
    ...mapGetters(["getEnrollment"]),
  },
});
